import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { Img, SectionLabel } from "./Img";

export function Breadcrumbs({ items }) {
  return (
    <nav aria-label="Breadcrumb" className="mb-6" data-testid="breadcrumbs">
      <ol className="flex flex-wrap items-center gap-1.5 font-mono text-[11px] uppercase tracking-[0.16em] text-slate-500">
        {items.map(([to, label], i) => (
          <li key={i} className="flex items-center gap-1.5">
            {i > 0 && <ChevronRight className="h-3 w-3" />}
            {to && i < items.length - 1 ? <Link to={to} className="hover:text-[color:var(--ice)]">{label}</Link> : <span className="text-slate-300">{label}</span>}
          </li>
        ))}
      </ol>
    </nav>
  );
}

export function PageHero({ page, crumbs, children, compact = false }) {
  if (!page) return <div className="h-[46vh] animate-pulse bg-[color:var(--bg-2)]" />;
  const img = page.hero_image;
  return (
    <section className={`grain relative overflow-hidden border-b border-[color:var(--line)] ${compact ? "pb-12 pt-10" : "pb-16 pt-12 lg:pb-24 lg:pt-16"}`} data-testid="page-hero">
      {img && (
        <div className="absolute inset-0">
          <Img src={img.url} alt={img.alt} eager sizes="100vw" className="h-full w-full object-cover opacity-35" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0b0d10] via-[#0b0d10]/85 to-[#0b0d10]/30" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0b0d10] to-transparent" />
        </div>
      )}
      <div className="knot-bg pointer-events-none absolute inset-0 opacity-[0.03]" />
      <div className="container-x relative">
        {crumbs && <Breadcrumbs items={crumbs} />}
        <div className="rise max-w-3xl">
          {page.eyebrow && <SectionLabel>{page.eyebrow}</SectionLabel>}
          <h1 className="mt-5 font-display text-4xl font-bold uppercase leading-[0.95] tracking-tight text-white sm:text-5xl lg:text-6xl" data-testid="page-h1">{page.h1 || page.title}</h1>
          {page.intro && <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-300 md:text-lg">{page.intro}</p>}
          {children}
        </div>
      </div>
    </section>
  );
}
